export default __webpack_public_path__ + "static/media/pdff.abc4dfe4.png";